import * as ko from "knockout";
import Bao from "./../services/bao-service";
import SearchPaging from "./../factories/search-paging";
import BaoDialog from "./../factories/bao-dialog";
import "./../bindings/bao-number-box";
function TextModuleViewModel(tabPage) {
    var self = this;
    self.ShiftbookId = ko.observable();
    self.ShiftbookName = ko.observable();
    SearchPaging.call(this, tabPage);
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.Name())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };

    self.ShiftbookSearcher = {
        SearchType: "Shiftbook",
        ObjectId: self.ShiftbookId,
        ObjectValue: "Name",
        AutoComplete: true,
        AutoSearch: true
    };
}
Bao.inherit(TextModuleViewModel, SearchPaging);
TextModuleViewModel.prototype.PrimaryKey = "TextModuleId";
TextModuleViewModel.prototype.RefreshUrl = "TextModule/Get";
TextModuleViewModel.prototype.SaveUrl = "TextModule/Save";
TextModuleViewModel.prototype.DeleteUrl = "TextModule/Delete";
TextModuleViewModel.prototype.IsInUseUrl = "TextModule/IsInUse";
TextModuleViewModel.prototype.PermissionForward = "TextModuleForward";
TextModuleViewModel.prototype.PermissionBackward = "TextModuleBackward";
TextModuleViewModel.prototype.PermissionSave = "TextModuleSave";
TextModuleViewModel.prototype.PermissionRefresh = "TextModuleRefresh";
TextModuleViewModel.prototype.PermissionDelete = "TextModuleDelete";
export default TextModuleViewModel;